import { useAxiosClient } from '../';

export const useMetricApi = () => {
    const { axiosClient, axiosClientNoResponseIntercept } = useAxiosClient(true);

    const buildClassCredentialConfig = (classLogin, classToken, classRole) => {
        if (!classLogin || !classToken) {
            return {};
        }

        const headers = {
            "X-Class-Login": classLogin,
            "X-Class-Token": classToken
        };

        if (classRole) {
            headers["X-Class-Role"] = classRole;
        }

        return { headers };
    };

    return {
        trailInfoList: async (page, itemsPerPage, dateFromFilter, dateToFilter) => (await axiosClient.get(`/v1/metric/TrailInfo?page=${page}&itemsPerPage=${itemsPerPage}&dateFrom=${dateFromFilter}&dateTo=${dateToFilter}`)).data,
        trailInfoReport: async (dateFromFilter, dateToFilter) => (await axiosClient.get(`/v1/metric/TrailInfo?dateFrom=${dateFromFilter}&dateTo=${dateToFilter}`)).data,
        userInfoList: async (page, itemsPerPage, dateFromFilter, dateToFilter) => (await axiosClient.get(`/v1/metric/UserInfo?page=${page}&itemsPerPage=${itemsPerPage}&dateFrom=${dateFromFilter}&dateTo=${dateToFilter}`)).data,
        userCountByCityInPeriodList: async (page, itemsPerPage, dateFromFilter, dateToFilter) => (await axiosClient.get(`/v1/metric/UserCountByCityInPeriod?page=${page}&itemsPerPage=${itemsPerPage}&dateFrom=${dateFromFilter}&dateTo=${dateToFilter}`)).data,
        courseProgressesBySchoolList: async (page, itemsPerPage, schoolId, language, classLogin, classToken, classRole) => {
            const languageParam = language ? `&language=${language}` : "";
            const config = buildClassCredentialConfig(classLogin, classToken, classRole);
            return (await axiosClientNoResponseIntercept.get(`/v1/metric/CourseProgressesBySchool?page=${page}&itemsPerPage=${itemsPerPage}&schoolId=${schoolId}${languageParam}`, config)).data;
        },
        generateReportProgressesSchool: async (schoolId, language, classLogin, classToken, classRole) => {
            const languageParam = language ? `&language=${language}` : "";
            const config = {
                ...buildClassCredentialConfig(classLogin, classToken, classRole),
                responseType: 'blob',
            };
            return (await axiosClientNoResponseIntercept.get(`/v1/metric/GenerateReportCourseProgresses?schoolId=${schoolId}${languageParam}`, config)).data;
        },
    }
}
